import _ from 'lodash'
import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexPersist = new VuexPersistence({
  key: 'vuex',
  storage: window.localStorage,
  reducer: state => ({
    isUserLoggedIn: state.isUserLoggedIn,
    user: state.user
  })
})

export default new Vuex.Store({
  plugins: [vuexPersist.plugin],
  state: {
    user: null,
    isUserLoggedIn: false
  },
  getters: {
    isUserLoggedIn: state => state.isUserLoggedIn,
    user: state => state.user,
    plan: state =>
      _.get(state, 'user.billingPlan') || {
        name: 'free',
        canceled: null,
        expire: null
      },
    isAdmin: state => _.get(state, 'user.isAdmin', false),
    isSubscribed: state => _.get(state, 'user.isSubscribed', false)
  },
  mutations: {
    LOGIN(state, { token, refreshToken, user }) {
      localStorage.setItem('x-token', token)
      localStorage.setItem('x-refresh-token', refreshToken)

      state.isUserLoggedIn = true
      state.user = { ...user }

      Promise.resolve()
    },
    LOGOUT(state) {
      localStorage.clear()

      state.isUserLoggedIn = false
      state.user = {}

      Promise.resolve()
    },
    SET_USER(state, user) {
      state.user = { ...state.user, ...user }
      Promise.resolve()
    }
  },
  actions: {
    login({ commit }, loginData) {
      commit('LOGIN', loginData)
    },
    logout({ commit }) {
      commit('LOGOUT')
    },
    setUser({ commit }, user) {
      commit('SET_USER', user)
    }
  }
})
